import { render } from "./Index.vue?vue&type=template&id=24e2ee4c"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Common/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24e2ee4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24e2ee4c', __exports__)) {
    api.reload('24e2ee4c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=24e2ee4c", () => {
    api.rerender('24e2ee4c', render)
  })

}


export default __exports__